/**
 * 业务错误对象。
 * 纪律 D9：分支判断用 code，不用 message 文本。
 * traceId 必须能带到界面上——用户报错时我们要靠它查日志。
 */
import { ErrCode, errMessage } from '@weidian/contracts'

export interface ApiErrorInit {
  traceId?: string | undefined
  data?: unknown
  httpStatus?: number | undefined
  /** true 表示压根没连上接口（后端未启动等），页面应走降级展示 */
  network?: boolean | undefined
}

export class ApiError extends Error {
  readonly code: number
  readonly traceId?: string | undefined
  readonly data?: unknown
  readonly httpStatus?: number | undefined
  readonly url: string
  readonly network: boolean

  constructor(code: number, message: string, url = '', init: ApiErrorInit = {}) {
    super(message || errMessage(code))
    this.name = 'ApiError'
    this.code = code
    this.url = url
    this.traceId = init.traceId
    this.data = init.data
    this.httpStatus = init.httpStatus
    this.network = init.network ?? false
  }

  /** 供界面展示：错误文案 + traceId（便于用户报错时提供） */
  toDisplayText(): string {
    return this.traceId ? `${this.message}（traceId: ${this.traceId}）` : this.message
  }
}

/** 需要按「未登录」处理的业务码 */
export function isUnauthorizedCode(code: number): boolean {
  return code === ErrCode.UNAUTHORIZED || code === ErrCode.TOKEN_EXPIRED || code === ErrCode.REFRESH_TOKEN_REUSED
}

/** 权限不足 */
export function isForbiddenCode(code: number): boolean {
  return code === ErrCode.FORBIDDEN
}

export function toApiError(e: unknown, fallback = '操作失败'): ApiError {
  if (e instanceof ApiError) return e
  if (e instanceof Error) return new ApiError(ErrCode.SYSTEM_BUSY, e.message || fallback, '')
  return new ApiError(ErrCode.SYSTEM_BUSY, fallback, '')
}
